import { Box, Grid, Stack, Typography, useTheme, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PreviewLeft from './Components/PreviewLeft';
import CloseIcon from '@mui/icons-material/Close';
import PreviewRight from './Components/PreviewRight';
import { getMeetingsList } from '../../../../../actions/meeting_actions';

const RegisterPreview = () =>
{
	const theme = useTheme();
	const navigate = useNavigate();
	const downSM = useMediaQuery(theme.breakpoints.down('md'));
	const type = new URLSearchParams(window.location.search).get('type');
	const heading = type ?? 'Completed';
	const { id } = useParams();
	const [ data, setData ] = useState<any>({});

	const handleNavigate = () =>
	{
		navigate('/webinars');
	};

	const GetWebinarData = async () =>
	{
		try
		{
			const queryParams:any = {
				id     : id ? window.atob(id) : '',
				status : heading,
				type   : 'webinar'

			};

			const res = await getMeetingsList(queryParams);

			if (res?.status)
			{
				setData(res?.data);
			}
			else
			{
				setData({});
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log('======================>', err);
		}
	};

	useEffect(() =>
	{
		GetWebinarData();
	}, []);

	return (
		<>
			<Grid container height='var(--pixel64)' sx={{ background: 'var(--whiteColor)' }} position={'sticky'} top={0} zIndex={9}>
				<Grid item xs={12} p='var(--pixel12)' alignItems={'center'}>
					<Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'space-between'}>
						<Box
							component='img'
							src='http://localhost:3000/images/logos/inLynk_Logo.svg'
							alt='inlynk logo'
							sx={{
								width      : '67.2px',
								height     : 'var(--pixel40)',
								alignItems : 'center'
							}}
						/>
						<Typography variant='h6' onClick={handleNavigate} style={{ cursor: 'pointer' }}>
							<CloseIcon />
						</Typography>
					</Stack>
				</Grid>
			</Grid>
			{data && Object?.keys(data)?.length > 0 &&
				<Grid container direction='column' sx={{ backgroundColor: 'var(--baseColor)' }} position={'relative'}>
					<Grid container direction={downSM ? 'column' : 'row'} maxWidth={'var(--percent100)'}>
						<Grid item xs={12} sm={5} md={6} lg={8} p={downSM ? 'var(--pixel16)' : 'var(--pixel24)'} sx={{ overflowY: 'auto' }} maxWidth={'100% !important'}>
							<PreviewLeft data={data}/>
						</Grid>
						<Grid item
							xs={12}
							sm={7}
							md={6}
							lg={4}
							p={downSM ? 'var(--pixel16)' : 'var(--pixel24)'}
							sx={{ overflowY: 'auto', minHeight: '100vh' }}
							width={'var(--percent100)'}
						>
							<PreviewRight data={data} />
						</Grid>
					</Grid>
				</Grid>
			}
		</>
	);
};

export default RegisterPreview;
